import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute(
  "/app/admin-settings/automatic-background-jobs/$id"
)({
  component: lazyImportRouteComponent(
    () => import("./-components/BackgroundJobDefinitionPage"),
    "BackgroundJobDefinitionPage"
  ),
})
